import { IIntegerPrecisionService } from '@core/interfaces/integer-precision-service.interface';
import { MenuItem, WorkDay } from '@core/models';
import { applyCouponDiscount } from './coupon-discount.util';
import { calculateCartItemTaxes } from './cart-taxes.util';
import { calculateCartItemSubtotal } from './cart-subtotal.util';
import { CartPriceField } from '../types/cart-price-field.type';
import { CartItemCalculation } from '../interfaces/cart-item-calculation.interface';

export function calculateCartItem(
	item: MenuItem,
	priceField: CartPriceField,
	couponDiscount: bigint,
	precisionService: IIntegerPrecisionService,
	workDay: WorkDay
): CartItemCalculation {
	const subtotal = calculateCartItemSubtotal(item, priceField);
	const subtotalAfterCoupon = applyCouponDiscount(subtotal, couponDiscount);

	return {
		subtotal,
		taxes: calculateCartItemTaxes(item, subtotalAfterCoupon, precisionService, workDay),
	};
}
